import React, { useEffect, useState } from 'react';
import AntComment from 'components/Common/AntComment';
import { faNumber } from 'utils/common.util';
import request from 'services/request';
import { CommentUrl, SendCommentUrl } from 'services/routes';
import { message, Skeleton } from 'antd';
import fa from 'locales/fa.json';
import AntButton from 'components/Common//AntButton';
import { CommentsType } from 'types/course.type';
import { SComment } from './style';

type CommentType = {
  data: CommentsType[];
  register: boolean;
  id: number;
  type: 'workshops' | 'events';
};

const Comments: React.FC<CommentType> = (props) => {
  const { data, id, register, type } = props;
  const [allData, setAllData] = useState(data);
  const [loading, setLoading] = useState(null);
  const [description, setDescription] = useState('');
  const [page, setPage] = useState(1);

  const handleLoadMore = async (): Promise<void> => {
    setLoading('loadMore');
    const res: any = await request.get(CommentUrl(id, page)); // eslint-disable-line
    setLoading(null);
    res.ok && setPage(page + 1);
    res.ok && setAllData([...allData, ...res.data.data]);
  };

  useEffect(() => {
    setAllData(data);
  }, [data]);

  const handleSubmit = async (): Promise<void> => {
    const body = { text: description };
    setLoading('send');
    const res: any = await request.post(SendCommentUrl(id, type), body); // eslint-disable-line
    setLoading(null);
    if (res.ok) {
      message.success(res.data.message);
      setDescription('');
    } else {
      message.warn(res.data.message);
    }
  };

  return (
    <div className="h-full overflow-hidden relative">
      <div className={`${register ? 'h-[calc(100%-180px)]' : 'h-full'}  overflow-auto`}>
        {!allData.length && <p className="toLeft p-[10px]">{fa.global.noCommentYet}</p>}
        {allData.map((item) => (
          <AntComment
            text={item.text}
            avatar={item.avatar}
            name={item.nickname}
            date={faNumber(item?.date?.split(' ')[0])}
            key={item.text}
          >
            {item.answer && (
              <AntComment
                text={item.answer.text}
                name={item.answer.nickname}
                date={faNumber(item?.date?.split(' ')[0])}
              />
            )}
          </AntComment>
        ))}
        {allData.length === 20 * page && (
          <div className="w-full px-[30px] text-center mb-[30px]">
            {loading === 'loadMore' ? (
              <Skeleton active />
            ) : (
              <AntButton width="200px" onClick={handleLoadMore}>
                {fa.course.loadMore}
              </AntButton>
            )}
          </div>
        )}
      </div>
      {register && (
        <div className="w-full center flex-col toLeft text-[16px]">
          <textarea
            onChange={(e): void => setDescription(e.target.value)}
            placeholder={fa.global.comment}
            value={description}
            className="border border-gray-5 rounded-[8px] w-[270px] md:w-[300px] h-[100px] my-[15px] p-[10px]"
          />
          <SComment
            onClick={handleSubmit}
            loading={loading === 'send'}
            disabled={!description}
          >
            {fa.course.sendComment}
          </SComment>
        </div>
      )}
    </div>
  );
};

export default Comments;
